import { Suspense } from 'react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  ANY_SPORT_HOME,
  FOOTBALL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useIsMobile } from '@sorare/core/src/hooks/device/useIsMobile';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { CurrentUserTaskUpdatedToast } from '@sorare/gameplay/src/components/missions/CurrentUserTaskUpdatedToast';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { LoyaltyBoxButton } from 'components/LoyaltyBoxButton';
import { Season26ReactivationDialog } from 'components/onboarding/Season26ReactivationDialog';
import { FootballMarketSubscriptions } from 'routing/FootballMarketSubscriptions';

const FootballLayout = () => {
  const { currentUser, footballUserProfile } = useCurrentUserContext();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { forcedIntoOnboarding } = currentUser || {};
  const {
    flags: { showS26WelcomeBack = false },
  } = useFeatureFlags();

  if (
    forcedIntoOnboarding &&
    !footballUserProfile?.commonGameOnboarded &&
    (matchPath(FOOTBALL, location.pathname) ||
      matchAnySportPath(ANY_SPORT_HOME, location.pathname, Sport.FOOTBALL))
  ) {
    return (
      <>
        <CurrentUserTaskUpdatedToast />
        <Outlet />
      </>
    );
  }
  return (
    <AppLayout extraHeaderButton={!isMobile && <LoyaltyBoxButton />}>
      <FootballMarketSubscriptions />
      <CurrentUserTaskUpdatedToast />
      {!!showS26WelcomeBack && <Season26ReactivationDialog />}
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  );
};
export default FootballLayout;
